import React from 'react'
import AuthorCard from './author-card'
import SubscribeCard from './subscribe-card'

const postSidebar = ({ data }) => {
  return (
    <div className='content-single__sidebar pl-12 md:pl-0 pr-12 py-12'>
      <div className='rounded-2xl p-6 border border-gray-light mb-12'>
        <div className='body-4 text-blue'>Date: {data?.post?.date}</div>
        {data?.post?.categories?.nodes[0]?.name ? (
          <div className='body-4 text-blue mt-2'>
            Subject: {data?.post?.categories?.nodes[0]?.name}
          </div>
        ) : (
          ''
        )}
      </div>

      {data?.post?.author ? (
        <AuthorCard
          className='mb-12'
          nodeType={data?.post?.nodeType}
          data={data?.post?.author?.node}
        />
      ) : (
        ''
      )}
      {data?.post?.nodeType === 'Productguide' ? '' : <SubscribeCard data={data} />}
    </div>
  )
}

export default postSidebar
